import { AuthorityService } from './authority.service';
import {Observable, empty} from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * æé
 */
export class Authority {
    
    constructor() {
        this.operationLabelMap = new Map<string, string>();
        this.authOfLabel = new Map<string, boolean>();
    }

    /**
     * ä»labelå°æä½æéIDçæ å°ï¼labelå¯ä»¥æ¯button idç­
     */
    private operationLabelMap: Map<string, string>;

    /**
     * è®°å½labelå¯¹äºçæä½æéï¼æ¯å¦éè¿
     */
    private authOfLabel: Map<string, boolean>;

    /**
     * è®¾ç½®labelå°operation idçæ å°
     * @param labelMap 
     */
    protected setLabelMap(labelMap: Object) {
        for(var i in labelMap) {
            this.operationLabelMap.set(i, labelMap[i]);
        }
        this.operationLabelMap.forEach((opId, label) => {
            this[label] = false;
        });        
    }
    
    /**
     * åå§åæéçå¼
     */
    initialize(authorityService: AuthorityService): Observable<void> {
        if(this.operationLabelMap && this.operationLabelMap.size>0) {
            return authorityService.queryOperationAuthority(Array.from(this.operationLabelMap.values())).pipe(
                map((operationAuth) => {
                    this.operationLabelMap.forEach((opId, label) => {
                        this.authOfLabel.set(label, operationAuth.has(opId) ? operationAuth.get(opId) : false);
                    });
                })
            );
        }else{
            return empty();
        }
    }

    /**
     * è¿åæä½æéï¼å³ç¨æ·æ¯å¦æ¥æLabelæå¯¹åºçæé
     * @param label æ ç­¾ï¼å¯ä»¥æ¯button idç­
     */
    hasOperation(label:string) {        
        return this.authOfLabel.has(label) && this.authOfLabel.get(label);
    }

    // è¿åå­æ®µæé
    // hasField(field:string)
}